import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

type MoneyIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}

/**
 * US Dollar sign icon
 */
export const MoneyIcon: FunctionComponent<MoneyIconProps> = ({ size = 32, fillColor, isFilled = false }) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  return (
    <Svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 32 32'
      testID={tID('MoneyIcon')}
      aria-label={formatMessage({
        defaultMessage: 'Money icon',
        description: 'Money icon',
      })}
      role='img'
    >
      {isFilled ? (
        <Path
          fill={fillColor || colors.iconInactive}
          fillRule='evenodd'
          d='M8 4H24C26.2133 4 28 5.78667 28 8V24C28 26.2133 26.2133 28 24 28H8C5.78667 28 4 26.2133 4 24V8C4 5.78667 5.78667 4 8 4ZM17 21.92V23C17 23.5467 16.5467 24 16 24C15.4533 24 15 23.5467 15 23V21.9067C13.2621 21.6087 12.1715 20.6405 11.9862 20.4761C11.9724 20.4639 11.9637 20.4561 11.96 20.4533C11.5733 20.0533 11.5733 19.4267 11.96 19.04C12.3467 18.64 12.9867 18.64 13.3733 19.04C13.4 19.0667 13.9867 19.6133 15 19.8533V16.8C13.32 16.44 11.3333 15.7333 11.3333 13.4667C11.3333 11.68 12.8 10.36 15 10.0533V9C15 8.45333 15.4533 8 16 8C16.5467 8 17 8.45333 17 9V10.08C18.8667 10.3867 19.9867 11.48 20.04 11.5333C20.4267 11.92 20.4267 12.5467 20.04 12.9467C19.6533 13.3333 19.0267 13.3333 18.6267 12.9467C18.6 12.92 18.0133 12.36 17 12.12V15.1867C18.68 15.5467 20.6667 16.2533 20.6667 18.5067C20.6667 20.2933 19.2 21.6133 17 21.92ZM15 14.7467V12.0933C14.0933 12.2667 13.3333 12.72 13.3333 13.4667C13.3333 14.1333 13.84 14.4533 15 14.7467ZM17 19.88C17.9067 19.7067 18.6667 19.2533 18.6667 18.5067C18.6667 17.8533 18.16 17.5333 17 17.2267V19.88Z'
          clipRule='evenodd'
        />
      ) : (
        <Path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='#343A40'
          d='M8 4H24C26.2133 4 28 5.78667 28 8V24C28 26.2133 26.2133 28 24 28H8C5.78667 28 4 26.2133 4 24V8C4 5.78667 5.78667 4 8 4ZM26 24C26 25.1067 25.1067 26 24 26H8C6.89333 26 6 25.1067 6 24V8C6 6.89333 6.89333 6 8 6H24C25.1067 6 26 6.89333 26 8V24ZM17 12.12V15.1867C18.68 15.5467 20.6667 16.2533 20.6667 18.5067C20.6667 20.2933 19.2 21.6133 17 21.92V23C17 23.5467 16.5467 24 16 24C15.4533 24 15 23.5467 15 23V21.9067C13.2621 21.6087 12.1715 20.6405 11.9862 20.4761C11.9724 20.4639 11.9637 20.4561 11.96 20.4533C11.5733 20.0533 11.5733 19.4267 11.96 19.04C12.3467 18.64 12.9867 18.64 13.3733 19.04C13.4 19.0667 13.9867 19.6133 15 19.8533V16.8C13.32 16.44 11.3333 15.7333 11.3333 13.4667C11.3333 11.68 12.8 10.36 15 10.0533V9C15 8.45333 15.4533 8 16 8C16.5467 8 17 8.45333 17 9V10.08C18.8667 10.3867 19.9867 11.48 20.04 11.5333C20.4267 11.92 20.4267 12.5467 20.04 12.9467C19.6533 13.3333 19.0267 13.3333 18.6267 12.9467C18.6 12.92 18.0133 12.36 17 12.12ZM13.3333 13.4667C13.3333 12.72 14.0933 12.2667 15 12.0933V14.7467C13.84 14.4533 13.3333 14.1333 13.3333 13.4667ZM17 19.88V17.2267C18.16 17.5333 18.6667 17.8533 18.6667 18.5067C18.6667 19.2533 17.9067 19.7067 17 19.88Z'
        />
      )}
    </Svg>
  )
}
